import FundingSearch from 'models/FundingSearchModel';

import {
  OPEN_FUNDING_SEARCH_PRIVACY_TOGGLE_MODAL,
  CLOSE_FUNDING_SEARCH_PRIVACY_TOGGLE_MODAL,
  fundingSearchPrivacyToggle,
} from './types';

export * from './actions';

const privacyToggleReducerObject = {
  [OPEN_FUNDING_SEARCH_PRIVACY_TOGGLE_MODAL]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['privateToggleFundingSearchModal', 'modalOpen'], true)
        .setIn(['privateToggleFundingSearchModal', 'fundingSearch'], action.fundingSearch),
    ),
  [CLOSE_FUNDING_SEARCH_PRIVACY_TOGGLE_MODAL]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['privateToggleFundingSearchModal', 'modalOpen'], false)
        .setIn(['privateToggleFundingSearchModal', 'fundingSearch'], false),
    ),

  [fundingSearchPrivacyToggle.success]: (state, action) =>
    state.setIn(['byId', action.fundingSearchId], FundingSearch.deserialize(action.response)),
};

export default privacyToggleReducerObject;
